/**
 * Loaders compartilhados entre lazy routes e prefetch (mesmo chunk Vite).
 * Convidar fica eager em App.tsx (caminho crítico com login/início).
 */

export function loadMenuPage() {
  return import('../pages/MenuPage').then((m) => ({ default: m.MenuPage }))
}

export function loadPerfilPage() {
  return import('../pages/PerfilPage').then((m) => ({ default: m.PerfilPage }))
}

const warmed = new Set<string>()

function warm(key: string, loader: () => Promise<unknown>): void {
  if (warmed.has(key)) return
  warmed.add(key)
  void loader().catch(() => {
    warmed.delete(key)
  })
}

/** Prefetch por chave da bottom nav (`rede`, `campanha`, `perfil`, …). */
export function prefetchHubNavKey(key: string): void {
  if (key === 'rede' || key === 'campanha') {
    warm('menu', loadMenuPage)
    return
  }
  if (key === 'perfil') {
    warm('perfil', loadPerfilPage)
  }
  // convidar: já no bundle principal — no-op
}

/**
 * Prefetch por path SPA do sidenav (paridade hover com bottom nav + listas quentes).
 */
export function prefetchHubSpaPath(path: string): void {
  const p = path.split('?')[0].replace(/\/$/, '') || '/hub'
  if (p === '/hub/perfil' || p.startsWith('/hub/cadastro') || p.startsWith('/hub/senha') || p.startsWith('/hub/ficha')) {
    prefetchHubNavKey('perfil')
    if (p.startsWith('/hub/cadastro')) warm('cadastro', () => import('../pages/CadastroPage'))
    if (p.startsWith('/hub/ficha')) warm('ficha', () => import('../pages/FichaPage'))
    if (p.startsWith('/hub/senha')) warm('senha', () => import('../pages/SenhaPage'))
    return
  }
  if (p === '/hub/rede' || p === '/hub/campanha') {
    prefetchHubNavKey(p === '/hub/rede' ? 'rede' : 'campanha')
    return
  }
  if (p.startsWith('/hub/equipe') || p.startsWith('/hub/convidados')) {
    warm('convidados', () => import('../pages/ConvidadosPage'))
    return
  }
  if (p.startsWith('/hub/medalhas')) {
    warm('medalhas', () => import('../pages/MedalhasPage'))
    return
  }
  if (p.startsWith('/hub/eventos')) {
    warm('eventos', () => import('../pages/EventosPage'))
    return
  }
  if (p.startsWith('/hub/noticias')) {
    warm('noticias', () => import('../pages/NoticiasPage'))
    return
  }
  if (p.startsWith('/hub/eu-apoio')) {
    warm('eu-apoio', () => import('../pages/EuApoioPage'))
    return
  }
  if (p.startsWith('/hub/colinha')) {
    warm('colinha', () => import('../pages/ColinhaPage'))
  }
}

/** Rotas quentes pós-boot: menus Rede/Campanha (+ Perfil da bottom nav). */
export function prefetchCriticalHubRoutes(): void {
  prefetchHubNavKey('rede')
  prefetchHubNavKey('perfil')
}

let scheduled = false

export function schedulePrefetchCriticalHubRoutes(): void {
  if (scheduled) return
  scheduled = true
  const run = () => prefetchCriticalHubRoutes()
  if (typeof window === 'undefined') return
  const ric = window.requestIdleCallback?.bind(window)
  if (ric) {
    ric(() => run(), { timeout: 2500 })
    return
  }
  window.setTimeout(run, 200)
}
